export default __webpack_public_path__ + "static/media/add-customer.4cc3dee2.svg";